import { InteractiveTable } from '@dreryk/react-components';

import {
   DiagnosesFromBeanPart,
   DiagnosisTableBean,
   VisitDocumentsDiagnosesFormController,
} from './VisitDocumentsDiagnosesForm.types';
import { useVisitDocumentsDiagnosesInteractiveTableColumnsConfiguration } from './VisitDocumentsDiagnosesInteractiveTable.hooks';
import { VisitDocumentsDiagnosesInteractiveTableSelector } from './VisitDocumentsDiagnosesInteractiveTableSelector';

type VisitDocumentsDiagnosesInteractiveTableProps = Pick<VisitDocumentsDiagnosesFormController, 'register'>;

export const VisitDocumentsDiagnosesInteractiveTable = (
   props: VisitDocumentsDiagnosesInteractiveTableProps
): JSX.Element => {
   const columns = useVisitDocumentsDiagnosesInteractiveTableColumnsConfiguration();

   return (
      <InteractiveTable<DiagnosisTableBean, DiagnosesFromBeanPart>
         testId={'diagnoses'}
         name={'diagnoses.value'}
         register={props.register}
         columns={columns}
         header={<VisitDocumentsDiagnosesInteractiveTableSelector register={props.register} />}
      />
   );
};
